module.exports = __webpack_public_path__ + "static/loading_more-cc2f35e1cf1c71f8d93784955b633d0b.png";